import { Component } from '@angular/core';
import { DealViewOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/deal-view/deal-view-wrapper.component';

@Component({
  selector: 'app-deal-view',
  templateUrl: './deal-view.component.html',
  styleUrls: ['./deal-view.component.scss'],
})
export class DealViewComponent extends DealViewOpenQuoteWrapper {

}
